import { useCallback } from 'react';

export const useEditLinkClick = (
  setSelectedUserId: (value: React.SetStateAction<number | null>) => void,
) => {
  const onEditLinkClick = useCallback<
    (e: React.MouseEvent<HTMLAnchorElement>, id: number) => void
  >(
    (e, id) => {
      e.preventDefault();
      e.stopPropagation();

      setSelectedUserId(id);
    },
    [setSelectedUserId],
  );

  return { onEditLinkClick };
};
